export const toHtml = (input: string = ''): string => {
  return `<p>${input.replace(/\\n+/g, '</p><p>')}</p>`.replace(/<p><\/p>/g, '');
};
